import { Pipe, PipeTransform } from '@angular/core';
import { TimeUnitsConverterService } from './time-units-converter.service';
import { NumberFormatter } from '../format/number-formatter';

@Pipe({ name: 'timeUnits' })
export class TimeUnitsPipe implements PipeTransform {
  constructor(
    private timeUnitsConverter: TimeUnitsConverterService,
    private numberFormatter: NumberFormatter,
  ) {}

  transform(value: number, forceHours?: boolean): string {
    return this.timeUnitsConverter.transform(value, forceHours);
  }
}
